import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from 'react-select'
import SelectStyles from "../../../shared/css/SelectStyle"
import api from "../../../utils/api"
import { FiChevronUp, FiChevronDown, FiInbox } from "react-icons/fi";
import { FaTshirt, FaBoxOpen, FaTruck, FaPalette, FaEye, FaPencilAlt, FaTrashAlt, FaListUl } from "react-icons/fa";

import AuthImage from "../../../shared/components/AuthImage/AuthImage"
import AuthBackgroundImage from "../../../shared/components/AuthImage/AuthBackgroundImage"

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import './FormBudget.css'
/* form */
import Input from "../../../shared/components/form/input"
import NewBudgetItem from "./Item/NewBudgetItem"
import NewBudgetSimpleItem from "./Item/NewBudgetSimpleItem"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
/* Hooks */
import useFlashMessage from "../../../hooks/useFlashMessage"
import NumberToMoney from "../../../shared/functions/NumberToMoney"
import EditBudgetItem from "./Item/EditBudgetItem"
import EditBudgetSimpleItem from "./Item/EditBudgetSimpleItem"
import useMyPermission from "../../../hooks/useMyPermission"

function FormBudget({ handleSubmit, budgetData, budgetItemArrayData, btnText, btCancelLink, btCancelAction, title, allowSellerSelect }) {


    const [budget, setBudget] = useState(budgetData || { paymentMethod: { selectName: "paymentMethod", label: "Á vista", value: "inCash" }, instalmentNumber: { selectName: "instalmentNumber", label: "1x", value: "1" }, additionalDiscount: 0 })
    const [budgetItemArray, setBudgetItemArray] = useState(budgetItemArrayData || [])
    const [token] = useState(localStorage.getItem('token') || '')
    const [userName] = useState(localStorage.getItem('userName') || '')
    const [clients, setClients] = useState([])
    const [paymentMethod, setPaymentMethod] = useState({ value: "inCash" })

    const [modalFormNewItem, setModalFormNewItem] = useState(false)
    const [modalFormNewSimpleProduct, setModalFormNewSimpleProduct] = useState(false)
    const [modalFormEditSimpleProduct, setModalFormEditSimpleProduct] = useState(false)
    const [modalFormEditItem, setModalFormEditItem] = useState(false)
    const [editItem, setEditItem] = useState({})
    const [clientId, setClientId] = useState()
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(null)
    const { setFlashMessage } = useFlashMessage()

    /* zoom img */
    const [modalZoomImg, setModalZoomImg] = useState(false)
    const [zoomImgUrl, setZoomImgUrl] = useState("")
    console.log("budget")
    console.log(budget)
    console.log("budgetItemArray")
    console.log(budgetItemArray)
    console.log(zoomImgUrl)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const [seller, setSeller] = useState({})
    const [sellerOptions, setSellerOptions] = useState([])
    const { checkPermission } = useMyPermission()
    const myPermissionAddicionalDiscount = checkPermission()
    const maxInstalment = (myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER")
        ? 10
        : Math.min(10, Math.max(1, parseInt(myPermission.budget_maxInstalment) || 1))
    useEffect(() => {

        api.get(`/order/budget/getinfo`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            if (response) {
                setClients(response.data.clients)
                setMyPermission(response.data.permission)
                // Editando um orçamento existente: mantém o vendedor que já estava, não troca pro
                // usuário que está editando. Só em um orçamento novo é que começa com o próprio usuário.
                setSeller(budgetData?.seller || response.data.user)
            }


        })

        // Lista de vendedores só é buscada quando a tela permite trocar o vendedor
        // (ex: "Todos os Orçamentos") — em "Meus Orçamentos" o vendedor é sempre o usuário logado.
        if (allowSellerSelect) {
            api.get(`/client/getselectinfo`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },
            }).then((response) => {
                if (response) {
                    setSellerOptions(response.data.users)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])
    console.log(seller)
    function handleChange(e) {

        setBudget({ ...budget, [e.target.name]: e.target.value })

    }
    //------------------------------ Select Handle On Change --------------------------
    const handleSelectChange = (selectedOption) => {
        if (selectedOption.selectName == "paymentMethod" && selectedOption.value == "inCash") {
            setBudget({ ...budget, [selectedOption.selectName]: selectedOption, instalmentNumber: { selectName: 'instalmentNumber', label: '1x', value: '1' } })
        } else {
            setBudget({ ...budget, [selectedOption.selectName]: selectedOption })
        }
    }
    const handleChangeSeller = (option) => {
        setSeller(sellerOptions.find((u) => u._id === option.value) || seller)
    }

    //Radio form start
    const handleChangeRadio = (name, value) => {

        setBudget({ ...budget, [name]: value })
    }

    //Radio form end

    const submit = () => {

        let data = {
            ...budget,
            nature: "Orçamento",
            status: "Criado",
            seller: seller,
            orderItemArray: budgetItemArray,
            totalPrice: NumberToMoney(calcTotalPrice()),
            orderPrice: NumberToMoney(calcTotalPrice() * (1 - (budget.additionalDiscount / 100))),
            orderCommission: calcTotalCommission(),


        }


        console.log("Orçamento")
        console.log(data)
        handleSubmit(data)
    }


    function handleFormNewProduct() {
        if (budget.client) {
            if (budget.client._id) {
                setClientId(budget.client._id)
                setModalFormNewItem(true)
            }
        } else {
            setFlashMessage("Selecione um Cliente", "error")
        }

    }
    function handleFormNewSimpleProduct() {
        if (budget.client) {
            if (budget.client._id) {
                setClientId(budget.client._id)
                setModalFormNewSimpleProduct(true)
            }
        } else {
            setFlashMessage("Selecione um Cliente", "error")
        }

    }
    const openBudgetItem = (id, status) => {

        if (id) {
            setBudgetItemArray((prev) => {
                return prev.map((i) => {
                    if (i.id === id) {
                        return { ...i, open: status }
                    } else {
                        return { ...i }
                    }
                })
            })
        }

    }

    const calcTotalCommission = () => {
        let comm = 0.0
        if (budgetItemArray) {
            budgetItemArray.map((i) => {
                if (budget.paymentMethod) {
                    if (budget.paymentMethod.value === "inCash") {
                        comm = comm + ((parseFloat(i.commissionValue) / 100) * parseFloat(i.totalInCash))
                    }
                    if (budget.paymentMethod.value === "instalment") {
                        comm = comm + ((parseFloat(i.commissionValue) / 100) * parseFloat(i.totalInstalment))
                    }
                }
            })
        }
        return NumberToMoney(comm)

    }

    const calcTotalPrice = () => {
        let price = 0.0
        if (budgetItemArray) {

            budgetItemArray.map((i) => {
                if (budget.paymentMethod) {
                    if (budget.paymentMethod.value === "inCash") {
                        price = price + parseFloat(i.totalInCash)

                    }
                    if (budget.paymentMethod.value === "instalment") {
                        console.log(i.totalInstalment)
                        price = price + parseFloat(i.totalInstalment)
                    }
                }

            })
        }

        return price
    }

    const calcFinalPrice = () => {
        return calcTotalPrice() * (1 - ((budget.additionalDiscount || 0) / 100))
    }

    const calcInstalmentValue = () => {
        const n = parseInt(budget.instalmentNumber?.value) || 1
        return calcFinalPrice() / n
    }

    const zoomImg = (url) => {
        setZoomImgUrl(url)
        setModalZoomImg(true)
    }
    return (




        <FormLayout
            title={title || 'Orçamento'}
            actions={
                <>
                    <Button variant="save" onClick={submit}>Salvar</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Identificação">
                <div className="fl-row">
                    <div className='fl-col-narrow form-group'>
                        <label>Código</label>
                        <div className='input-block'> {budget.code} </div>
                    </div>
                    <div className='fl-col-narrow form-group'>
                        <label>Vendedor</label>
                        {allowSellerSelect ? (
                            <Select
                                options={sellerOptions.map((u) => ({ value: u._id, label: u.name }))}
                                styles={SelectStyles}
                                onChange={handleChangeSeller}
                                value={seller && seller._id ? { value: seller._id, label: seller.name } : null}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                        ) : (
                            <div className='input-block'> {seller?.name || userName} </div>
                        )}
                    </div>
                    <div className='fl-col-narrow form-group'>
                        <Input
                            text="Pedido do Cliente"
                            type="text"
                            name="clientOrderNumber"
                            placeholder="nº do pedido do cliente"
                            handleOnChange={handleChange}
                            value={budget.clientOrderNumber || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Cliente:</label>
                        <Select
                            options={clients}
                            styles={SelectStyles}
                            onChange={handleSelectChange}
                            value={budget.client || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"

                        />
                    </div>

                </div>
            </FormSection>

            <FormSection label="Itens do Orçamento">
                <div className="budget-item-actions">
                    <button type="button" className="budget-item-action-btn budget-item-action-product" onClick={() => { handleFormNewProduct() }}>
                        <FaTshirt size={16} /><span>+ Produto</span>
                    </button>
                    <button type="button" className="budget-item-action-btn budget-item-action-simple" onClick={() => { handleFormNewSimpleProduct() }}>
                        <FaBoxOpen size={16} /><span>+ Produto Simples</span>
                    </button>
                </div>
                <section className="box-itens">
                    {budgetItemArray && budgetItemArray.length > 0 ? (
                        budgetItemArray.map((x) => (
                            <div className="budget-item-card" key={x.id}>
                                <div className="bic-main">
                                    <span className="bic-code">#{x.code}</span>
                                    <span className="bic-desc">{x.description}</span>
                                    <div className="bic-field">
                                        <label>Quant.</label>
                                        <span>{x.totalQuantity}</span>
                                    </div>
                                    <div className="bic-field">
                                        <label>Desconto</label>
                                        <span>{x.discountValue}%</span>
                                    </div>
                                    <div className="bic-field bic-total">
                                        <label>Total</label>
                                        <span>R$ {budget.paymentMethod.value === "inCash" ? x.totalInCash : x.totalInstalment}</span>
                                    </div>
                                    <div className="bic-field">
                                        <label>Comissão</label>
                                        <span>R$ {budget.paymentMethod.value === "inCash" ? NumberToMoney(parseFloat(x.totalInCash) * parseFloat(x.commissionValue) / 100) : NumberToMoney(parseFloat(x.totalInstalment) * parseFloat(x.commissionValue) / 100)}</span>
                                    </div>
                                    <div className="bic-actions">
                                        {!x.simpleProduct && (
                                            <div className="bic-icon-expand-wrap" title={x.open ? "Recolher" : "Expandir"} onClick={() => openBudgetItem(x.id, !x.open)}>
                                                <FaListUl className="bic-icon-expand-list" />
                                                <span className="bic-icon-expand-badge">
                                                    {x.open ? <FiChevronUp size={9} /> : <FiChevronDown size={9} />}
                                                </span>
                                            </div>
                                        )}
                                        <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setEditItem(x); if (x.simpleProduct) { setModalFormEditSimpleProduct(true) } else { setModalFormEditItem(true) } }} />
                                        <FaTrashAlt className="shd-icon-row-trash" title="Remover" onClick={() => { setItemToDelete(x); setModalDeleteItem(true) }} />
                                    </div>
                                </div>

                                {x.open && !x.simpleProduct && (
                                    <div className="bic-details">
                                        <div className="bic-detail-section">
                                            <label className="bic-detail-label">Tecido</label>
                                            <span className="bic-detail-value">{x.cloth?.label}</span>
                                        </div>
                                        <div className="bic-detail-section">
                                            <label className="bic-detail-label">Sexo</label>
                                            <span className="bic-detail-value">{x.sex?.label}</span>
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Cor</label>
                                            {x.colors && x.colors.length > 0 ? (
                                                <div className="bscc-list">
                                                    {x.colors.map((i) => (
                                                        <div className="bscc-item" key={i._id}>
                                                            <AuthBackgroundImage className="bscc-swatch" src={i.image ? `/images/color/${i.image}` : null} onClick={() => zoomImg(`/images/color/${i.image}`)} />
                                                            <div className="bscc-info">
                                                                <div className="bscc-name">{i.name}</div>
                                                                <div className="bscc-meta">
                                                                    {i.provider?.name && <span className="bscc-meta-item"><FaTruck size={11} />{i.provider.name}</span>}
                                                                    {i.cloth?.name && <span className="bscc-meta-item"><FaTshirt size={11} />{i.cloth.name}</span>}
                                                                    {i.colorType?.name && <span className="bscc-meta-item"><FaPalette size={11} />{i.colorType.name}</span>}
                                                                </div>
                                                                <div className="bscc-ref">Ref.: {i.ref}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhuma cor selecionada.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Acessórios</label>
                                            {x.accessoriesSelected && x.accessoriesSelected.length > 0 ? (
                                                <div className="budget-accessory-list">
                                                    {x.accessoriesSelected.map((i) => (
                                                        <div className="budget-accessory-item" key={i.id || i._id}>
                                                            <div className="budget-accessory-thumb-wrap" onClick={() => i.image && zoomImg(`/images/accessory/${i.image}`)}>
                                                                <AuthBackgroundImage className="budget-accessory-thumb" src={i.image ? `/images/accessory/${i.image}` : null} />
                                                                {i.image && (
                                                                    <div className="budget-accessory-thumb-zoom">
                                                                        <FaEye size={14} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="budget-accessory-info">
                                                                <span className="budget-accessory-name">{i.name}</span>
                                                                {i.description && <span className="budget-accessory-desc">{i.description}</span>}
                                                                {(i.price ?? i.cost) > 0 && <span className="budget-accessory-cost">R$ {NumberToMoney(i.price ?? i.cost)}</span>}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhum acessório selecionado.</span>}
                                        </div>

                                        <div className="bic-detail-section">
                                            <label className="bic-detail-label">Aditivo</label>
                                            {x.additive && x.additive.some((i) => i.checked === true) ? (
                                                <div className="bic-chip-list">
                                                    {x.additive.map((i) => i.checked === true && (
                                                        <span className="bic-chip" key={i._id}>Com {i.name}</span>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhum aditivo selecionado.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Imagens de referência</label>
                                            {x.clientImgsSelected && x.clientImgsSelected.length > 0 ? (
                                                <div className="bic-img-grid">
                                                    {x.clientImgsSelected.map((i) => (
                                                        <div className="bic-img-tile" key={i.id || i._id} onClick={() => zoomImg(`/images/clientImg/${i.image}`)}>
                                                            <AuthBackgroundImage className="bic-img-bg" src={i.image ? `/images/clientImg/${i.image}` : null} />
                                                            <div className="bic-img-zoom"><FaEye size={13} /></div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhuma imagem selecionada.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Bordado</label>
                                            {x.embroidery && x.embroidery.length > 0 ? (
                                                <div className="budget-print-list">
                                                    {x.embroidery.map((i) => (
                                                        <div className="budget-print-item" key={i._id}>
                                                            <div className="budget-print-thumb" onClick={() => i.image && zoomImg(`/images/clientImg/${i.image}`)}>
                                                                <AuthBackgroundImage className="budget-print-thumb-bg" src={i.image ? `/images/clientImg/${i.image}` : null} />
                                                                {i.image && (
                                                                    <div className="budget-print-thumb-zoom">
                                                                        <FaEye size={14} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="budget-print-info">
                                                                <span className="budget-print-position">{i.position?.label}</span>
                                                                {i.description && <span className="budget-print-desc">{i.description}</span>}
                                                                <span className="budget-print-price">R$ {NumberToMoney(i.price)}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhum bordado adicionado.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Estampa</label>
                                            {x.prints && x.prints.length > 0 ? (
                                                <div className="budget-print-list">
                                                    {x.prints.map((i) => (
                                                        <div className="budget-print-item" key={i._id}>
                                                            <div className="budget-print-thumb" onClick={() => i.image && zoomImg(`/images/clientImg/${i.image}`)}>
                                                                <AuthBackgroundImage className="budget-print-thumb-bg" src={i.image ? `/images/clientImg/${i.image}` : null} />
                                                                {i.image && (
                                                                    <div className="budget-print-thumb-zoom">
                                                                        <FaEye size={14} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="budget-print-info">
                                                                <span className="budget-print-position">{i.position?.label}</span>
                                                                {i.description && <span className="budget-print-desc">{i.description}</span>}
                                                                <span className="budget-print-price">R$ {NumberToMoney(i.price)}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : <span className="bic-empty">Nenhuma estampa adicionada.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-wide">
                                            <label className="bic-detail-label">Observação</label>
                                            {x.obs ? <span className="bic-detail-value">{x.obs}</span> : <span className="bic-empty">Sem observações.</span>}
                                        </div>

                                        <div className="bic-detail-section bic-detail-full">
                                            <label className="bic-detail-label">Tamanhos</label>
                                            <div className="bic-size-list">
                                                {x.sizes.map((s) => s.quantity && s.quantity > 0 && (
                                                    <div className="bic-size-chip" key={s._id}>
                                                        <span className="bic-size-chip-name">{s.name}</span>
                                                        <span className="bic-size-chip-qty">{s.quantity}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="pg-empty">
                            <FiInbox size={32} className="pg-empty-icon" />
                            <p className="pg-empty-title">Nenhum item adicionado ainda</p>
                            <p className="pg-empty-subtitle">Use os botões acima para adicionar um Produto ou Produto Simples ao orçamento.</p>
                        </div>
                    )}
                </section>
            </FormSection>

            <FormSection label="Pagamento">
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Forma de Pagamento:</label>
                        <Select
                            options={[{ selectName: "paymentMethod", label: "Á vista", value: "inCash" }, ...(maxInstalment > 1 ? [{ selectName: "paymentMethod", label: "Parcelado", value: "instalment" }] : [])]}
                            styles={SelectStyles}
                            onChange={handleSelectChange}
                            value={budget.paymentMethod}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"

                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Parcelas{maxInstalment < 10 && <span className="budget-instalment-limit-tag"> (máx. {maxInstalment}x)</span>}:</label>
                        <Select
                            options={[
                                { selectName: "instalmentNumber", label: "1x", value: "1" },
                                { selectName: "instalmentNumber", label: "2x", value: "2" },
                                { selectName: "instalmentNumber", label: "3x", value: "3" },
                                { selectName: "instalmentNumber", label: "4x", value: "4" },
                                { selectName: "instalmentNumber", label: "5x", value: "5" },
                                { selectName: "instalmentNumber", label: "6x", value: "6" },
                                { selectName: "instalmentNumber", label: "7x", value: "7" },
                                { selectName: "instalmentNumber", label: "8x", value: "8" },
                                { selectName: "instalmentNumber", label: "9x", value: "9" },
                                { selectName: "instalmentNumber", label: "10x", value: "10" },
                            ].filter((o) => parseInt(o.value) <= maxInstalment)}
                            styles={SelectStyles}
                            maxMenuHeight={150}
                            onChange={handleSelectChange}
                            value={budget.instalmentNumber}
                            isDisabled={budget.paymentMethod.value == "inCash" ? true : false}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"

                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Desconto Adicional (%)"
                            type="number"
                            name="additionalDiscount"
                            placeholder="desconto"
                            disabled={false}
                            handleOnChange={handleChange}
                            value={budget.additionalDiscount || 0}
                        />
                    </div>
                </div>
                <div className="budget-total-tiles">
                    <div className="budget-total-tile">
                        <span className="budget-total-tile-label">Valor Total</span>
                        <span className="budget-total-tile-value">R$ {calcTotalPrice()}</span>
                    </div>
                    {budget.additionalDiscount > 0 && (
                        <div className="budget-total-tile budget-total-tile-highlight">
                            <span className="budget-total-tile-label">Com Desconto Adicional</span>
                            <span className="budget-total-tile-value">R$ {NumberToMoney(calcFinalPrice())}</span>
                        </div>
                    )}
                    {budget.paymentMethod?.value === "instalment" && parseInt(budget.instalmentNumber?.value) > 1 && (
                        <div className="budget-total-tile">
                            <span className="budget-total-tile-label">Valor da Parcela</span>
                            <span className="budget-total-tile-value">{budget.instalmentNumber.label} de R$ {NumberToMoney(calcInstalmentValue())}</span>
                        </div>
                    )}
                    <div className="budget-total-tile">
                        <span className="budget-total-tile-label">Comissão</span>
                        <span className="budget-total-tile-value">R$ {calcTotalCommission()}</span>
                    </div>
                </div>
            </FormSection>

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => {
                    setBudgetItemArray(prev => prev.filter((item) => item.id !== itemToDelete.id))
                    setModalDeleteItem(false)
                }}
                message="Deseja realmente excluir esse item do orçamento?"
                itemName={itemToDelete?.description}
            />

            {/* NEW ITEM MODAL */}
            <Modal
                modalStatus={modalFormNewItem}
                changeStatus={setModalFormNewItem}
                t={2}
                w={94}
                h={94}

                content={
                    <>
                        <NewBudgetItem permission={myPermission} clientId={clientId} handleOnAddItem={(item) => setBudgetItemArray([...budgetItemArray, item])} handleOnSuccess={() => { setModalFormNewItem(false) }} />
                    </>
                }

            />

            <Modal
                modalStatus={modalFormEditItem}
                changeStatus={setModalFormEditItem}
                t={2}
                w={94}
                h={94}
                content={
                    <>
                        <EditBudgetItem item={editItem}
                            handleOnEditItem={(item) => {
                                let array = budgetItemArray.filter((i) => i.id != item.id)
                                setBudgetItemArray([...array, item])

                            }}
                            handleOnSuccess={() => { setModalFormEditItem(false) }}
                            btCancelAction={() => setModalFormEditItem(false)}
                            clientId={clientId}
                            permission={myPermission}
                        />
                    </>
                }

            />

            {/*  modal simple product */}
            <Modal
                modalStatus={modalFormNewSimpleProduct}
                changeStatus={setModalFormNewSimpleProduct}
                t={3}
                w={94}
                h={94}

                content={
                    <>
                        <NewBudgetSimpleItem clientId={clientId} handleOnAddItem={(item) => setBudgetItemArray([...budgetItemArray, item])} handleOnSuccess={() => { setModalFormNewSimpleProduct(false) }} />
                    </>
                }

            />
            <Modal
                modalStatus={modalFormEditSimpleProduct}
                changeStatus={setModalFormEditSimpleProduct}
                t={3}
                w={94}
                h={94}
                content={
                    <>

                        <EditBudgetSimpleItem item={editItem}
                            handleOnEditItem={(item) => {
                                let array = budgetItemArray.filter((i) => i.id != item.id)
                                setBudgetItemArray([...array, item])

                            }}
                            clientId={clientId}
                            handleOnSuccess={() => {
                                setModalFormEditSimpleProduct(false)

                            }}
                            btCancelAction={() => setModalFormEditSimpleProduct(false)} />
                    </>
                }

            />


            <Modal
                modalStatus={modalZoomImg}
                changeStatus={setModalZoomImg}
                t={10}
                w={96}
                h={80}
                content={
                    <div className="shd-box-img-zoom-box">

                        <AuthImage className="shd-box-img-zoom" src={zoomImgUrl} />
                    </div>


                }

            />

        </FormLayout>
    )
}

export default FormBudget